// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1945":"3fba07c2","3039":"3fba07c2","3260":"3fba07c2","5413":"3fba07c2","7070":"3fba07c2","8436":"3fba07c2"}[chunkId] + ".chunk.css";
};